import { fromJS, List, Map, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { IFilter } from '../interfaces/filter.interface';
import { FilterTypesEnum } from '../reports.enum';
import { Card } from './card.model';
import { FilterDate } from './filter-date.model';
import { FilterNonDate } from './filter-non-date.model';
import { Table } from './table.model';

export const REPORT_SCHEMA = Object.freeze({
  TITLE: '',
  NAME: '',
  VISUALS: List<Card>([]),
  TABLES: List<Table>([]),
  FILTER: null, // IFilter,
});
const RECORD = generateSchema(REPORT_SCHEMA);
const KEYS: any = generateKeys(REPORT_SCHEMA);

export class Report extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.VISUALS,
        value: props.get(KEYS.VISUALS)
          ? this.visuals.map((params) => new Card(params))
          : List<Card>([]),
      },
      {
        key: KEYS.TABLES,
        value: props.get(KEYS.TABLES)
          ? this.tables.map((params) => new Table(params))
          : List<Table>([]),
      },
      {
        key: KEYS.FILTER,
        value: props.get(KEYS.FILTER)
          ? this._reportFilterFactory(props.get(KEYS.FILTER))
          : null,
      },
    ]);

    return selfModel as Report;
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get name(): string {
    return this.get(KEYS.NAME);
  }

  get visuals(): List<Card> {
    return this.get(KEYS.VISUALS);
  }

  get tables(): List<Table> {
    return this.get(KEYS.TABLES);
  }

  get reportFilter(): IFilter {
    // parent class already have filter attribute
    return this.get(KEYS.FILTER);
  }

  private _reportFilterFactory(props: Map<string, any>): IFilter {
    const filterType: string = props.get('type');

    switch (filterType) {
      case FilterTypesEnum.date:
        return new FilterDate(props);
      case FilterTypesEnum.non_date:
        return new FilterNonDate(props);
      default:
        throw new Error(`Unsupported report filter type: ${filterType}.`);
    }
  }
}
